<div class="modal1Main" *ngIf="userData?.id > 0">
  <div class="modalHeader" *ngIf="parentPage==='Join'">
    <span class="title">
      <div class="teammenu_icon" *ngIf="isMobile && !data['lobby']"><i class="zmdi zmdi-menu"></i></div> Verification
    </span>
    <button class="closepop float-right" mat-dialog-close><i class="zmdi zmdi-close"></i></button>
  </div>
  <div *ngIf="isAwareVerification">
    <div *ngIf="isQrcode">
      <div class="verificationSteps">
        <ol>
          <li>Step 1: Scan QR Code and Continue on Mobile</li>
          <li>Step 2: Liveness Check</li>
          <li>Step 3: Scan ID</li>
        </ol>
      </div>
      <p class="verificationProcess">This process will take under 1 minute!</p>
      <div class="mobileApp active" *ngIf="(deviceType=='Android' || deviceType == 'iOS')">
        <div class="smart-body">
          <div class="smart-cardContainer">
            <a *ngIf="deviceType=='iOS'" href="http://apps.apple.com/us/app/drafters-fantasy-sports/id1273975920/" target="_blank" class="smartbanner-icon">
              <img src="{{assetURL}}/assets/default/new/images/appstore_2.png" alt="">
            </a>
            <a *ngIf="deviceType=='Android'" href="https://app2.drafters.info/uC18" target="_blank" class="smartbanner-icon">
                <img src="{{assetURL}}/assets/default/new/images/googlestore_2.png" alt="">
            </a>
          </div>
        </div>
      </div>
      <div class="qucodeContainer" *ngIf="(deviceType!='Android' && deviceType != 'iOS')">
        <canvas #qrCanvas></canvas>
      </div>
    </div>
    <div class="verificationSteps qrcodeBtn" *ngIf="!isQrcode">
      <button mat-raised-button class="qrCode" (click)="showQrcode()">Begin Verification</button>
    </div>
  </div>
  <div id="content" class="verifyMainPage" *ngIf="!isAwareVerification">
    <div id="main-content">
      <div #kycTab class="verificationMain verifyForm" [ngClass]="data['lobby'] ? 'isFtpProcess' : ''"
        *ngIf="(userData && userData.verification_attempts < 2 && uploadTab ==false);else uploaddoc">
        <form [formGroup]="verificationFrom" (ngSubmit)="onVerificationSubmit(kycTab)">
          <flash-messages></flash-messages>
          <p class="alert flash-message alert-warning text-center verify-acc-msg"
            *ngIf="(userData.verification_attempts==0 && hideAlert==false)">
            <button aria-label="Close" class="close ng-star-inserted" data-dismiss="alert" type="button"
              (click)="uploadDocAction('hide')"><span aria-hidden="true">×</span></button>
            For added account security and fair play, please verify your account! This should only take 1-2 minutes.
          </p>
          <p class="alert flash-message alert-warning text-center"
            *ngIf="(userData.verification_attempts==1 && hideAlert== false)">
            <button aria-label="Close" class="close ng-star-inserted" data-dismiss="alert" type="button"
              (click)="uploadDocAction('hide')"><span aria-hidden="true">×</span></button>
            We could not verify your account with Tsevo. Please try again with different information or <a
              href="javascript:void(0)" (click)="uploadDocAction('change')" style="color:blue;" class="uploaddoc">click
              here</a> to upload documents..
          </p>
          <div class="documents-verification-msg">
            <div class="documents-verification-img">
              <img
                [src]="darkMode ? 'assets/images/verification-img-dark.png ': 'assets/images/verification-img-light.png' "
                alt="">
            </div>
            <div class="documents-verification-txt">
              <span>
                Enter your information as per your Government documents.
              </span>
            </div>
          </div>
          <div class="formElement">
            <div class="verificationIn name-container">
              <div class="verifyRightDouble">
                <mat-form-field appearance="outline" class="formcontrol">
                  <mat-label>First Name</mat-label>
                  <input matInput formControlName="FirstName" type="text" maxlength="50">
                </mat-form-field>
                <mat-error *ngIf="verificatioSubmitted && v.FirstName.errors && v.FirstName.errors.required">
                  First Name is required.
                </mat-error>
              </div>
              <div class="verifyRightDouble">
                <mat-form-field appearance="outline">
                  <mat-label>Last Name</mat-label>
                  <input matInput formControlName="LastName" type="text" maxlength="50">
                </mat-form-field>
                <mat-error *ngIf="verificatioSubmitted && v.LastName.errors && v.LastName.errors.required">
                  Last Name is required.
                </mat-error>
              </div>
            </div>
            <div class="verificationIn address-container">
              <div class="verifyRightDouble">
                <mat-form-field appearance="outline">
                  <mat-label>Email Address</mat-label>
                  <input matInput formControlName="EmailAddress" type="text">
                </mat-form-field>
                <mat-error *ngIf="verificatioSubmitted && v.EmailAddress.errors && v.EmailAddress.errors.required">
                  Email is required.
                </mat-error>
                <mat-error *ngIf="verificatioSubmitted && v.EmailAddress.errors && v.EmailAddress.errors.email">
                  Invalid email address.
                </mat-error>
              </div>
              <div class="verifyRightDouble" *ngIf="userData?.verify_phone == 'N' || userData?.primary_number == ''">
                <mat-form-field appearance="outline">
                  <mat-label>Phone Number</mat-label>
                  <input matInput formControlName="phoneNumber" (keypress)="keyPress($event)">
                </mat-form-field>
                <mat-error *ngIf="verificatioSubmitted && v.phoneNumber.errors && v.phoneNumber.errors.required">
                  Phone number is required.
                </mat-error>
                <mat-error
                  *ngIf="verificatioSubmitted && v.phoneNumber.errors && (v.phoneNumber.errors.minlength || v.phoneNumber.errors.maxlength)">
                  Invalid format (Expected format is xxx-xxx-xxxx).
                </mat-error>
              </div>
            </div>
            <div class="verificationIn">
              <div class="verifyRight w-100 date-of-birth">
                <div class="dob">
                  <mat-form-field floatLabel='never' appearance="outline">
                    <mat-label>Date of Birth</mat-label>
                    <mat-select formControlName="dd">
                      <mat-option *ngFor="let drec of dateList" [value]="drec.key">{{ drec.value }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="dob">
                  <mat-form-field floatLabel='never' appearance="outline">
                    <mat-label>Month of Birth</mat-label>
                    <mat-select formControlName="mm">
                      <mat-option [value]="">Month</mat-option>
                      <mat-option *ngFor="let mrec of monthList" [value]="mrec.key">{{ mrec.value }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="dob">
                  <mat-form-field floatLabel='never' appearance="outline">
                    <mat-label>Year of Birth</mat-label>
                    <mat-select formControlName="yyyy">
                      <mat-option [value]="">Date</mat-option>
                      <mat-option *ngFor="let yrec of yearList" [value]="yrec.key">{{ yrec.value }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <mat-error
                  *ngIf="verificatioSubmitted && ((v.yyyy.errors && v.yyyy.errors.required) || (v.mm.errors && v.mm.errors.required) || (v.dd.errors && v.dd.errors.required))">
                  Date of birth is required.
                </mat-error>
              </div>
            </div>
            <div class="verificationIn">
              <div class="verifyRight w-100">
                <mat-form-field appearance="outline">
                  <mat-label>Address</mat-label>
                  <input matInput formControlName="AddressLine1" type="text">
                </mat-form-field>
                <mat-error *ngIf="verificatioSubmitted && v.AddressLine1.errors && v.AddressLine1.errors.required">
                  Address is required.
                </mat-error>
              </div>
            </div>
            <div class="verificationIn address-container">
              <div class="verifyRightDouble">
                <mat-form-field appearance="outline">
                  <mat-label>City</mat-label>
                  <input matInput formControlName="city" type="text">
                </mat-form-field>
                <mat-error *ngIf="verificatioSubmitted && v.city.errors && v.city.errors.required">
                  City is required.
                </mat-error>
              </div>

              <div class="verifyRightDouble">
                <mat-form-field appearance="outline" floatLabel='never'>
                  <mat-label>Country</mat-label>
                  <mat-select formControlName="CountryCode" (selectionChange)="getStateList($event.value)">
                    <mat-option *ngFor="let country of countryList" [value]="country.code">{{ country.name
                      }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-error *ngIf="verificatioSubmitted && v.CountryCode.errors && v.CountryCode.errors.required">
                  Country is required.
                </mat-error>
              </div>
            </div>
            <div class="verificationIn address-container">
              <div class="verifyRightDouble">
                <mat-form-field floatLabel='never' appearance="outline">
                  <mat-label>State/province</mat-label>
                  <mat-select formControlName="StateCode">
                    <mat-option *ngFor="let state of stateList" [value]="state.code">{{ state.name }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-error *ngIf="verificatioSubmitted && v.StateCode.errors && v.StateCode.errors.required">
                  State is required.
                </mat-error>
              </div>

              <div class="verifyRightDouble">
                <mat-form-field appearance="outline">
                  <mat-label>Postal Code</mat-label>
                  <input matInput formControlName="PostalCode" type="text" maxlength="10">
                </mat-form-field>
                <mat-error *ngIf="verificatioSubmitted && v.PostalCode.errors && v.PostalCode.errors.required">
                  Postal Code is required.
                </mat-error>
              </div>

            </div>
            <div class="text-center verificationIn verification-button">
              <button mat-raised-button type="submit" color="primary" [disabled]="isDisable"
                class="popupFormBtn">Submit</button>
            </div>
          </div>
        </form>
      </div>
      <ng-template #uploaddoc>
        <div [ngClass]="showUploadIdSuccessBox == true ? 'verifyForm alert-overlay-container' : 'verifyForm'">
          <form [formGroup]="uploadDocForm" (ngSubmit)="onDocSubmit()"[ngClass]="data['lobby'] ? 'isFtpProcess' : ''">
            <flash-messages></flash-messages>
            <div class="cusPopup" id="cusPopup2" *ngIf="showUploadIdSuccessBox">
              <div class="alert-verify">
                <div class="msg_text">Thanks for uploading your ID. You will receive an email when it has been reviewed,
                  This may take up to 24 hours.</div>
              </div>
            </div>
            <div class="formControlMain pT20">
              <div class="text-center">
                <div class="documents-verification-msg" *ngIf="!showUploadIdSuccessBox">
                  <div class="documents-verification-img">
                    <img
                      [src]="darkMode ? 'assets/images/verification-img-dark.png ': 'assets/images/verification-img-light.png' "
                      alt="">
                  </div>
                  <div class="documents-verification-txt">
                    <span>
                      Please upload a Valid Piece of Government issued ID.
                    </span>
                  </div>
                </div>
                <p class="alert flash-message alert-warning text-center"
                  *ngIf="(userData.doc_upload==1 && showUploadIdSuccessBox== false)">
                  We could not verify with Tsevo. Please try again with different document..
                </p>
                <div class="idUploadInput" *ngIf="imageSrc==null">
                  <button mat-raised-button type="submit" color="primary" *ngIf="!showUploadIdSuccessBox"><img
                      src="assets/images/upload-img.png"> Choose File</button>
                  <input type="file" formControlName="document" (change)="onSelectFile($event.target.files)">
                </div>
                <div class="rowInfo">
                  <p> Step 1: Click on "Choose File" to upload Document.</p>
                  <p>Step 2: After choosing, you will see the preview of document and "Upload ID" button.</p>
                  <p> Step 3: Click on Upload ID Button to submit the document.</p>
                </div>
                <div class="row text-center" *ngIf="imageSrc!=null">
                  <div class="col-md-6">
                    <img id="output" [src]="imageSrc" style="max-width:300px;max-height:300px;" />
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center width100 pt-15" *ngIf="imageSrc!=null">
              <button mat-raised-button class="resetImgBtn" (click)="resetFile()">Reset</button>
              <button mat-raised-button type="submit" class="popupFormBtn" [disabled]="isSubmitting">Upload ID</button>
            </div>
          </form>
        </div>
      </ng-template>
    </div>
  </div>
</div>